module.exports = ".footer {\n    /* workaround boostrap pagination z-index */\n    z-index: 3;\n}\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/app.component.css
// module id = ./src/app/app.component.css
// module chunks = main